// @ts-check
if (!customElements.get('ff-search-popup')) {
  class FfSearchPopup extends HTMLElement {
    constructor() {
      super();
      this.ffBound = false;
    }

    connectedCallback() {
      if (this.ffBound) return;
      this.ffBound = true;

      this.closeBtn = this.querySelector('[data-ff-search-close]');
      this.input = this.querySelector('.ff-search-popup__input');
      this.form = this.querySelector('.ff-search-popup__form');

      // Intercept all header search triggers
      this.ffBindTriggers();

      // Close handlers
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.ffClose);
      }

      // ESC as accessibility baseline (standard for modal dialogs)
      document.addEventListener('keydown', this.ffHandleKey);
    }

    ffBindTriggers = () => {
      document.querySelectorAll('[data-ff-search-trigger]').forEach((trigger) => {
        if (trigger._ffSearchBound) return;
        trigger._ffSearchBound = true;
        trigger.addEventListener('click', this.ffHandleTriggerClick);
      });
    };

    ffHandleTriggerClick = (e) => {
      e.preventDefault();
      this.ffOpen();
    };

    ffOpen = () => {
      this.removeAttribute('hidden');
      document.body.classList.add('ff-search-popup--open');
      // Focus input after next frame so transitions/layout settle
      requestAnimationFrame(() => {
        if (this.input) this.input.focus();
      });
    };

    ffClose = () => {
      this.setAttribute('hidden', '');
      document.body.classList.remove('ff-search-popup--open');
      if (this.input) this.input.value = '';
    };

    ffHandleKey = (e) => {
      if (e.key === 'Escape' && !this.hasAttribute('hidden')) {
        this.ffClose();
      }
    };

    disconnectedCallback() {
      document.removeEventListener('keydown', this.ffHandleKey);
    }
  }

  customElements.define('ff-search-popup', FfSearchPopup);
}

// Editor support: re-bind triggers when header re-renders
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('ff-search-popup').forEach((popup) => {
      if (typeof popup.ffBindTriggers === 'function') popup.ffBindTriggers();
    });
  });
}
